/**
 * @package soulgood-custom
 *
 * Entry point for Javascript package
 */

// Imports
import HashNavigator from './components/hash-navigation';
import MobileMenu from './components/menu-controller';

// Init hashnavigator
HashNavigator();

// Init repsonsive menu
MobileMenu();

// Import rellax
const headerElement = <HTMLElement>document.getElementById('header-main');

const isMobile = window.matchMedia('(max-width: 980px)').matches;

if (!isMobile) {
  // @ts-ignore
  new Rellax('.rellax', {
    center: true,
  });
}

// Get logo ele for safari fix
const logoEle = <HTMLElement>headerElement.querySelector('.header__logo svg');

function changeHeaderOnScroll() {
  if (window.scrollY > 100) {
    headerElement.dataset.hasScrolled = 'true';
    setTimeout(() => {
      logoEle.style.height = 'unset';
      setTimeout(() => {
        logoEle.style.height = '100%';
      }, 0);
    }, 1);
  } else {
    headerElement.dataset.hasScrolled = 'false';
    setTimeout(() => {
      logoEle.style.height = 'unset';
      setTimeout(() => {
        logoEle.style.height = '100%';
      }, 0);
    }, 1);
  }
}

window.addEventListener('scroll', changeHeaderOnScroll, { passive: true });

// Ninja forms styling workaround
function nfLoaded() {
  const ninjaFormsFieldContainers = <NodeListOf<HTMLElement>>(
    document.querySelectorAll('.nf-field-container')
  );

  ninjaFormsFieldContainers.forEach((container) => {
    const parent = container.parentElement;

    container.classList.forEach((className) => {
      if (className.startsWith('w--')) {
        parent.classList.add(className);
      }
    });
  });
}

// @ts-ignore fuck jquery and ninja forms
jQuery(document).on('nfFormReady', nfLoaded);

// Echo packs scroll effects
// const echoPacksContainer = document.querySelector('.echo-packs');
// const echoPackWrapper = document.querySelector('.echo-packs__wrapper');
// const firstEchoPack = <HTMLDivElement>document.querySelector('.echo-pack');
// let packWidth: number;

// function removeAnimationFromWrapper(event: Event) {
//   const target = <HTMLElement>event.target;

//   if (target.scrollLeft > packWidth / 2) {
//     echoPacksContainer.classList.add('no-anim');
//   }
// }

// if (echoPackWrapper) {
//   packWidth = firstEchoPack.offsetWidth;
//   echoPackWrapper.addEventListener('scroll', removeAnimationFromWrapper);
// }
